export default {"src":"/_next/static/media/reach_logo_rgb_white.ad64c4bf.svg","height":66,"width":296,"blurWidth":0,"blurHeight":0};